// src/shared/ui/notifications/toast.ts
import { Toast } from "./types";

type Listener = (toasts: Toast[]) => void;

let toasts: Toast[] = [];
let listeners: Listener[] = [];

const emit = () => listeners.forEach((l) => l(toasts));

const addToast = (type: Toast["type"], message: string) => {
  const id = Math.random().toString(36).substring(2, 9);
  toasts = [...toasts, { id, type, message }];
  emit();

  const duration = type === "error" ? 6000 : 4000;
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== id);
    emit();
  }, duration);
};

export const toast = {
  success: (msg: string) => addToast("success", msg),
  error: (msg: string) => addToast("error", msg),
  info: (msg: string) => addToast("info", msg),
  warning: (msg: string) => addToast("warning", msg),
  remove: (id: string) => {
    toasts = toasts.filter((t) => t.id !== id);
    emit();
  },
  subscribe: (listener: Listener) => {
    listeners.push(listener);
    listener(toasts);
    return () => { listeners = listeners.filter((l) => l !== listener); };
  },
};